module.exports = __webpack_public_path__ + "static/media/shaff1137.07bcb476.jpg";